export type UpdateAdCategoryExclusionsParams = {
  webStationId: string;
  adCategories: string[];
};

export async function updateAdCategoryExclusions({
  webStationId,
  adCategories,
}: UpdateAdCategoryExclusionsParams) {
  try {
    const response = await fetch(
      `/api/proxy/v3/stations/webStationId:${webStationId}/adCategoryExclusions`,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
          adCategories,
        }),
      }
    );
    if (response.ok) {
      return response;
    }
    throw new Error(
      `Unable to update ad category exclusions for ${webStationId}`
    );
  } catch (err) {
    throw new Error(err.message);
  }
}
